module.exports = {
  /* If input is an empty string, return null */
  emptyToNull: function (str) {
    return str ? str : null
  },
  /* Add ISO timestamp to a date if input is a non-empty string */
  dateToTimestamp: function (str) {
    return str ? str + 'T00:00:00' : null
  },
  /* Check for valid EAN */
  isEan: function (str) {
    return this.isDigits(str) && str.length >= 6;
  },
  isDigits: function (str) {
    return  /^\d+$/.test(str)
  },
  inclusiveDateTimestamp: function (str) {
    return  str ? str + 'T23:59:59.99999' : null
  },
  addQueryParam: function (values, param) {
    if(values.length === 0) {
      return null
    } else {
      let params =  new URLSearchParams()
      values.forEach(id => params.append(param, id))
      return params.getAll(param).toString()
    }
  }
}
